module.exports = __webpack_public_path__ + "static/media/Impreza-Hawk-GG-Wagon-WRX.f41f60db.jpg";